import _defineProperty from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default (function (_ref) {
  var _ref2;

  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return _ref2 = {
    /**
     * @description 缴纳保证金
     */
    deposit: function deposit() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                return _context.abrupt("return", request({
                  url: '/finance/deposit',
                  data: data
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 退还保证金
     * @param {Object} data
     */
    refundDeposit: function refundDeposit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/refundDeposit',
        data: data
      });
    },

    /**
     * @description 保证金缴纳/退还 详情
     * @param {Object} data
     */
    depositDetails: function depositDetails() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/depositDetails',
        data: data
      });
    },

    /**
     * @description 保证金 差额和记录
     * @param {Object} data
     */
    depositList: function depositList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/depositList',
        data: data
      });
    },

    /**
     * @description 获取店铺保证金缴纳金额、银行账户
     * @param {Object} data
     */
    depositInfo: function depositInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/depositInfo',
        data: data
      });
    },

    /**
     * @description 账单查询
     * @param {Object} data
     */
    bills: function bills() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/bills',
        data: data
      });
    },

    /**
     * @description 保存发票信息
     * @param {Object} data
     */
    saveInvoice: function saveInvoice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/saveInvoice',
        data: data
      });
    },

    /**
     * @description 申请提现
     * @param {Object} data
     */
    transfer: function transfer() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/transfer',
        data: data
      });
    },

    /**
     * @description 可提现的单据列表
     * @param {Object} data
     */
    canTransferBills: function canTransferBills() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/canTransferBills',
        data: data
      });
    },

    /**
     * @description 上次提现 填写的银行信息
     * @param {Object} data
     */
    cacheInfo: function cacheInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/cacheInfo',
        data: data
      });
    }
  }, _defineProperty(_ref2, "transfer", function transfer() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return request({
      url: '/finance/transfer',
      data: data
    });
  }), _defineProperty(_ref2, "balance", function balance() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return request({
      url: '/finance/balance',
      data: data
    });
  }), _defineProperty(_ref2, "transferList", function transferList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return request({
      url: '/finance/transferList',
      data: data
    });
  }), _defineProperty(_ref2, "transferDetails", function transferDetails() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return request({
      url: '/finance/transferDetails',
      data: data
    });
  }), _defineProperty(_ref2, "billList", function billList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return request({
      url: '/finance/billList',
      data: data
    });
  }), _ref2;
});